module.exports = __webpack_public_path__ + "img/home-back@2x.4bf80190.png";